import { Question } from "../../../API";
import { Player } from "../../game/Types/GameTypes_dep";
import { Team } from "../../game/Types/TeamTypes";
import * as xlsx from "xlsx";

type TableRow = {
  nickname: string;
  teamNo: number;
  score: string;
  answerMarks: boolean[];
};

export function exportResultsTable(
  players: Player[],
  teams: Team[],
  questions: (Question | null | undefined)[]
) {
  const rows: TableRow[] = players.map((player) => {
    const nickname = player.nickname;
    const team = teams.find((team) => team.id === player.groupId);
    if (!team) return { nickname, teamNo: 0, score: "0%", answerMarks: [] };
    const teamNo = teams.indexOf(team) + 1;
    const numCorrect = team.gameData.answerResults.filter(
      (r) => r.isCorrect
    ).length;
    const totalQuestions = questions.length;

    const score = `${(numCorrect / totalQuestions) * 100}%`;

    const answerMarks = questions.map((_, i) => {
      const answerResult = team.gameData.answerResults.find(
        (r) => r.questionIndex === i
      );
      return answerResult?.isCorrect ?? false;
    });

    return { nickname, teamNo, score, answerMarks };
  });

  const headers = [
    "Nickname",
    "Team #",
    "Score",
    ...questions.map((q, i) => `Q${i + 1}: ${q?.text ?? ""}`),
  ];
  const data = [
    headers,
    ...rows.map((row) => [
      row.nickname,
      row.teamNo,
      row.score,
      ...row.answerMarks.map((mark) => (mark ? 1 : 0)),
    ]),
  ];

  const worksheet = xlsx.utils.aoa_to_sheet(data);
  const workbook = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(workbook, worksheet, "Results");

  const date = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  xlsx.writeFile(workbook, `Gibbly_Game_Results_${date}.csv`);
}
